import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { CommentAgentSessionButtonProps } from '../src/components/CommentAgentSessionButton.tsx';

/**
 * Code-split wrapper for CommentAgentSessionButton.
 *
 * The button (and its transitive deps — AvatarWithActionButton, @atlaskit/avatar,
 * @atlaskit/button, @atlaskit/icon, AgentAvatar, useCommentAgentSession) is only needed on
 * the rare path where the cc_ai_agent_mention_from_comment experiment is on AND a comment has
 * an agent session. Importing it statically into view-page-critical surfaces (e.g. the inline
 * comment popup) would ship all of that in the initial bundle for everyone. This keeps it in a
 * separate chunk that loads only when the gated component is actually rendered.
 *
 * Render this behind the experiment gate so the chunk is not fetched when the experiment is off.
 */
export const CommentAgentSessionButtonAsync: LoadableType<CommentAgentSessionButtonProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-CommentAgentSessionButton" */ '../src/components/CommentAgentSessionButton.tsx'
				)
			).CommentAgentSessionButton,
	});
